import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import ElectricOven from '@/components/UI/svg/solar-calculator/ElectricOven';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import Dryer from '@elem/SVGIcon/Homebattery/Dryer';
import Fan from '@elem/SVGIcon/OutdoorRecreation/Fan';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import AirConditioner from 'elem/SVGIcon/PowerBackup/AirConditioner';
import BigPhone from 'elem/SVGIcon/PowerBackup/BigPhone';
import Capacity from 'elem/SVGIcon/PowerBackup/Capacity';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import ElectricBlanket from 'elem/SVGIcon/PowerBackup/ElectricBlanket';
import Laptop from 'elem/SVGIcon/PowerBackup/Laptop';
import Light from 'elem/SVGIcon/PowerBackup/Light';
import Microwave from 'elem/SVGIcon/PowerBackup/Microwave';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import Setup from 'elem/SVGIcon/PowerBackup/Setup';
import SwitchOver from 'elem/SVGIcon/PowerBackup/SwitchOver';
import Washer from 'elem/SVGIcon/PowerBackup/Washer';
import WaterPump from 'elem/SVGIcon/VanlifeRoadtrips/WaterPump';
import EFPicture from 'elem/compCommon/EFPicture';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import caConfig from './caConfig';
import css from './index.module.scss';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import gtm from 'eco-design-reliance/gtm';

const IMG_MAP_kv: any = {
    us: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711422586324/3_day_outages_1366.jpg',
        pad: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711422577055/3_day_outages_768.jpg',
    },
    ca: { pc: '/responsive/picture/power-backup/7.jpg', pad: '/responsive/picture/power-backup/7_pad.jpg' },
    kr: { pc: '/responsive/picture/power-backup/7_kr.jpg', pad: '/responsive/picture/power-backup/7_pad_kr.jpg' },
    au: { pc: '/responsive/picture/power-backup/7_au.jpg', pad: '/responsive/picture/power-backup/7_pad_au.jpg' },
};

export default function G() {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const [open, setOpen] = useState(false);
    const IS_NA_SITES = ['us', 'ca']?.includes(locale);

    const { caCardList } = caConfig();

    const icons: any = [
        {
            icon: <Capacity className="icon" />,
            text: t('secG_icon1'),
        },
        {
            icon: <Setup className="icon" />,
            text: t('secG_icon2'),
        },
        {
            icon: <SwitchOver className="icon" />,
            text: t('secG_icon3'),
        },
        {
            icon: <BigPhone className="icon" />,
            text: t('secG_icon4'),
        },
    ];

    const cardsAll: any = [
        {
            tag: t('common_card_tag_new_arrival'),
            power: IS_NA_SITES ? '4kWh | 4000W｜120V/240V' : t('secG_card1_power'),
            title: IS_NA_SITES ? 'EcoFlow DELTA Pro 3' : t('secG_card1_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384599194',
                    au: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/ecoflow-delta2',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                    au: '7914502422726',
                    kr: '8687916187817',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                    au: '43045698371782',
                    kr: '46400158990505',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: IS_NA_SITES
                ? ['2600W dual-port solar input', '10 ms UPS', 'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2']
                : [
                      t('secG_card1_desc1'),
                      t('secG_card1_desc2'),
                      t.rich('secG_card1_desc3', {
                          ts: (text: string) => (
                              <Link className="ts" href={t('secG_card1_desc3_link')}>
                                  {text}
                              </Link>
                          ),
                      }),
                  ],
            iconArr: [
                {
                    icon: IS_NA_SITES ? <WaterPump className="card-icon" /> : <Light className="card-icon" />,
                    title: t.rich('secG_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon1_desc'),
                },
                {
                    icon: IS_NA_SITES ? <AirConditioner className="card-icon" /> : <Phone className="card-icon" />,
                    title: t.rich('secG_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon2_desc'),
                },
                {
                    icon: IS_NA_SITES ? (
                        <ElectricOven className="card-icon oven" />
                    ) : ['au', 'kr'].includes(locale) ? (
                        <Laptop className="card-icon" />
                    ) : (
                        <Refrigerator className="card-icon" />
                    ),
                    title: t.rich('secG_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon3_desc'),
                },
                {
                    icon: IS_NA_SITES ? (
                        <EFElectricHeater className="card-icon g" />
                    ) : ['au'].includes(locale) ? (
                        <Refrigerator className="card-icon" />
                    ) : (
                        <EFTV className="card-icon" />
                    ),
                    title: t.rich('secG_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon4_desc'),
                },
                {
                    icon: IS_NA_SITES ? (
                        <Microwave className="card-icon" />
                    ) : ['au'].includes(locale) ? (
                        <CoffeeMaker className="card-icon" />
                    ) : (
                        <Refrigerator className="card-icon" />
                    ),
                    title: t.rich('secG_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon5_desc'),
                },
                {
                    icon: IS_NA_SITES ? (
                        <Refrigerator className="card-icon" />
                    ) : ['au'].includes(locale) ? (
                        <Microwave className="card-icon" />
                    ) : (
                        <ElectricBlanket className="card-icon" />
                    ),
                    title: t.rich('secG_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon6_desc'),
                },
            ],
        },
        {
            tag: t('common_card_tag_recommended'),
            power: t('secG_card2_power'),
            title: t('secG_card2_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
                    au: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/delta2-max',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                    au: '7914502422726',
                    kr: '8687917072553',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '44223441404102',
                    ca: '43725958873242',
                    au: '41793295155398',
                    kr: '46400200343721',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                t('secG_card2_desc1'),
                t('secG_card2_desc2'),
                t.rich('secG_card2_desc3', {
                    ts: (text: string) => (
                        <Link className="ts" href={t('secG_card2_desc3_link')}>
                            {text}
                        </Link>
                    ),
                }),
            ],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secG_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secG_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon2_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <CoffeeMaker className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <Laptop className="card-icon" />
                    ) : (
                        <Refrigerator className="card-icon" />
                    ),
                    title: t.rich('secG_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon3_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <Fan className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <EFTV className="card-icon" />
                    ) : (
                        <CoffeeMaker className="card-icon" />
                    ),
                    title: t.rich('secG_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon4_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <CarFridge className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <Refrigerator className="card-icon" />
                    ) : (
                        <Microwave className="card-icon" />
                    ),
                    title: t.rich('secG_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon5_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <Projector className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <ElectricBlanket className="card-icon" />
                    ) : (
                        <AirConditioner className="card-icon" />
                    ),
                    title: t.rich('secG_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon6_desc'),
                },
            ],
        },
        ...(locale === 'us'
            ? [
                  {
                      tag: t('common_card_tag_new_arrival'),
                      power: t('secG_card5_power'),
                      title: t('secG_card5_title'),
                      link_more: (() => {
                          const localMap: any = {
                              us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      productId: (() => {
                          const localMap: any = {
                              us: '6585086836809',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      variantId: (() => {
                          const localMap: any = {
                              us: '40516140138569',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      descArr: [
                          t('secG_card5_desc1'),
                          t('secG_card5_desc2'),
                          t.rich('secG_card5_desc3', {
                              ts: (text: string) => (
                                  <Link className="ts" href={t('secG_card5_desc3_link')}>
                                      {text}
                                  </Link>
                              ),
                          }),
                      ],
                      iconArr: [
                          {
                              icon: <Light className="card-icon" />,
                              title: t.rich('secG_card5_icon1_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon1_desc'),
                          },
                          {
                              icon: <Projector className="card-icon" />,
                              title: t.rich('secG_card5_icon2_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon2_desc'),
                          },
                          {
                              icon: <Washer className="card-icon" />,
                              title: t.rich('secG_card5_icon3_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon3_desc'),
                          },
                          {
                              icon: <CoffeeMaker className="card-icon" />,
                              title: t.rich('secG_card5_icon4_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon4_desc'),
                          },
                          {
                              icon: <Microwave className="card-icon" />,
                              title: t.rich('secG_card5_icon5_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon5_desc'),
                          },
                          {
                              icon: <WaterPump className="card-icon" />,
                              title: t.rich('secG_card5_icon6_title', {
                                  s: (text: string) => <span className="s-text">{text}</span>,
                              }),
                              desc: t('secG_card5_icon6_desc'),
                          },
                      ],
                  },
              ]
            : []),
        {
            power: t('secG_card3_power'),
            title: t('secG_card3_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-double-voltage-hub',
                    au: 'https://au.ecoflow.com/products/delta-pro-smart-extra-battery-bundle',
                    kr: 'https://kr.ecoflow.com/products/delta-pro-extra-battery-bundle',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6807191879753',
                    ca: '7683662610586',
                    au: '7253218296006',
                    kr: '7717851201705',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40435774980169',
                    ca: '7683662610586',
                    au: '42994601066694',
                    kr: '43452387426473',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secG_card3_desc1'), t('secG_card3_desc2'), t('secG_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secG_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secG_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon2_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secG_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secG_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secG_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secG_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card3_icon6_desc'),
                },
            ],
        },
    ];

    if (IS_NA_SITES) {
        cardsAll.unshift({
            tag: t('common_card_tag_new_arrival'),
            power: t('secG_card4_power'),
            title: t('secG_card4_title'),
            link_more: (() => {
                const localMap: any = {
                    us: '/delta-pro-ultra',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6964802453577',
                    ca: '8006700236954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40758830071881',
                    ca: '44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                t('secG_card4_desc1'),
                t('secG_card4_desc2'),
                t.rich('secG_card4_desc3', {
                    ts: (text: string) => (
                        <Link className="ts" href={t('secG_card4_desc3_link')}>
                            {text}
                        </Link>
                    ),
                }),
            ],
            iconArr: [
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secG_card4_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon1_desc'),
                },
                {
                    icon: <Washer className="card-icon" />,
                    title: t.rich('secG_card4_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon2_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secG_card4_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon3_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secG_card4_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon4_desc'),
                },
                {
                    icon: <Dryer className="card-icon" />,
                    title: t.rich('secG_card4_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon5_desc'),
                },
                {
                    icon: <WaterPump className="card-icon" />,
                    title: t.rich('secG_card4_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon6_desc'),
                },
            ],
        });
    }

    const cards = ['au', 'kr'].includes(locale) ? cardsAll.slice(0, 2) : locale === 'ca' ? caCardList : cardsAll.slice(0, 4);
    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        if (card?.inventoryPolicy !== 'continue' && Number(card?.inventoryQuantity || 0) <= 0) return;
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secG_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="power-backup-G" className={`power-backup-G ef-layer ${css['power-backup-G']}`}>
            <div className="text-box">
                <p className="subtitle">{t('secG_subtitle')}</p>
                <p className="title">{t('secG_title')}</p>
                <p className="desc">{t('secG_desc')}</p>
                <div className="icon-wrapper">
                    <ul className="icons" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                        {icons?.map((icon: any, k: number) => (
                            <li className="icon-item" key={k}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <EFPicture
                className="back-img"
                src={IMG_MAP_kv[locale]?.pc}
                srcPad={IMG_MAP_kv[locale]?.pad}
                srcMobile={IMG_MAP_kv[locale]?.pad}
                alt={t('secG_title')}
            />
            <ul className="cards common-cards">
                {cardLists?.map((card: any, k: number) => (
                    <li className="card-item" key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <EFPicture src={card?.variantImg || card?.img} alt={card?.title || card?.productTitle || card?.skuTitle} />
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <ul className={`card-icons${open ? ' open' : ''}`}>
                            {card?.iconArr?.map((icon: any, n: number) => (
                                <li className="card-icon-item" key={`${k}_${n}`}>
                                    {icon?.icon}
                                    <p className="icon-title">{icon?.title}</p>
                                    <p className="icon-desc">{icon?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        {!open && (
                            <span className="card-arrow" onClick={() => setOpen(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                    <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        )}
                        <div className="card-btns">
                            {card?.link_buy && locale === 'kr' ? (
                                <div className="card-btn-cart">
                                    <button
                                        className={`kr-shop${
                                            Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                        }`}
                                        onClick={() =>
                                            (Number(card?.inventoryQuantity || 0) > 0 || card?.inventoryPolicy === 'continue') &&
                                            window.open(card?.link_buy, '_blank')
                                        }
                                    >
                                        {t('common_card_buy_new')}
                                    </button>
                                    <button
                                        className={`kr-add-cart${
                                            Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                        }`}
                                        onClick={() => handleBuy(card)}
                                    >
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z"
                                                fill="currentColor"
                                                stroke="currentColor"
                                                stroke-width="0.3"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            ) : (
                                card?.link_buy && (
                                    <>
                                        {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                            <button disabled className={`btn-buy card-btn disabled`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )
                            )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${
                                        String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                    }utm_source=scenario+page&utm_medium=Pillar`}
                                    target="_blank"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        list_name: t('secG_title'),
                                        product_name: card.title,
                                        button_name: t('common_card_more'),
                                    }}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </li>
                ))}
            </ul>

            <Swiper
                className="cards swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item card-item item-${k + 1}`} key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <EFPicture src={card?.img} alt={card?.title} />
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <ul className={`card-icons${open ? ' open' : ''}`}>
                            {card?.iconArr?.map((icon: any, n: number) => (
                                <li className="card-icon-item" key={`${k}_${n}`}>
                                    {icon?.icon}
                                    <p className="icon-title">{icon?.title}</p>
                                    <p className="icon-desc">{icon?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        {!open && (
                            <span className="card-arrow" onClick={() => setOpen(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                    <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        )}
                        <div className="card-btns">
                            {card?.link_buy && locale === 'kr' ? (
                                <div className="card-btn-cart">
                                    <button
                                        className={`kr-shop${
                                            Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                        }`}
                                        onClick={() => window.open(card?.link_buy, '_blank')}
                                    >
                                        {t('common_card_buy_new')}
                                    </button>
                                    <button
                                        className={`kr-add-cart${
                                            Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                        }`}
                                        onClick={() => handleBuy(card)}
                                    >
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z"
                                                fill="currentColor"
                                                stroke="currentColor"
                                                stroke-width="0.3"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            ) : (
                                card?.link_buy && (
                                    <>
                                        {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                            <button disabled className={`btn-buy card-btn disabled`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )
                            )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${
                                        String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                    }utm_source=scenario+page&utm_medium=Pillar`}
                                    target="_blank"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        list_name: t('secG_title'),
                                        product_name: card.title,
                                        button_name: t('common_card_more'),
                                    }}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
